import * as s from "react";
const l = (c) => /* @__PURE__ */ s.createElement(
  "svg",
  {
    id: "pci-dss-compliant-logo_svg__layer",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 652 652",
    xmlSpace: "preserve",
    ...c
  },
  /* @__PURE__ */ s.createElement("style", null, ".pci-dss-compliant-logo_svg__st0{enable-background:new}.pci-dss-compliant-logo_svg__st1{fill:#225e63}.pci-dss-compliant-logo_svg__st2{fill:#fefefe}"),
  /* @__PURE__ */ s.createElement("g", { transform: "translate(0 -8)", id: "pci-dss-compliant-logo_svg__Page-1" }, /* @__PURE__ */ s.createElement("g", { className: "pci-dss-compliant-logo_svg__st0" }, /* @__PURE__ */ s.createElement(
    "path",
    {
      className: "pci-dss-compliant-logo_svg__st1",
      d: "M430.5 345.2l6 1.8c-.4 1.7-1 3.1-1.9 4.2-.9 1.1-1.9 2-3.2 2.5-1.3.6-2.9.9-4.9.9-2.4 0-4.3-.3-5.9-1-1.5-.7-2.8-1.9-3.9-3.7-1.1-1.7-1.7-4-1.7-6.7 0-3.6 1-6.4 2.9-8.4s4.7-2.9 8.2-2.9c2.8 0 4.9.6 6.5 1.7 1.6 1.1 2.8 2.8 3.5 5.2l-6 1.3c-.2-.7-.4-1.2-.7-1.5-.4-.5-.8-.9-1.4-1.2-.6-.3-1.2-.4-1.8-.4-1.5 0-2.7.6-3.5 1.9-.6.9-.9 2.4-.9 4.3 0 2.4.4 4.1 1.1 5 .7.9 1.8 1.4 3.1 1.4s2.3-.4 2.9-1.1c.8-.9 1.3-1.9 1.6-3.3zM438.9 343.2c0-3.6 1-6.4 3-8.4s4.8-3 8.4-3c3.7 0 6.5 1 8.5 2.9 2 2 3 4.7 3 8.3 0 2.6-.4 4.7-1.3 6.3-.9 1.6-2.1 2.9-3.8 3.8-1.6.9-3.7 1.4-6.1 1.4-2.5 0-4.5-.4-6.2-1.2-1.6-.8-2.9-2-4-3.8s-1.5-3.7-1.5-6.3zm6.8 0c0 2.2.4 3.8 1.2 4.8.8 1 1.9 1.5 3.4 1.5s2.6-.5 3.4-1.4c.8-1 1.2-2.7 1.2-5.1 0-2.1-.4-3.6-1.3-4.5-.8-1-2-1.4-3.4-1.4s-2.5.5-3.3 1.5c-.8.8-1.2 2.4-1.2 4.6zM465.3 332.2h8.9l3.4 13.4 3.4-13.4h8.9v22h-5.6v-16.8l-4.3 16.8h-5l-4.3-16.8v16.8h-5.6v-22zM494.3 332.2h11.3c2.5 0 4.3.6 5.5 1.8 1.2 1.2 1.8 2.8 1.8 5s-.7 4-2 5.2c-1.3 1.3-3.4 1.9-6.1 1.9h-3.7v8.2h-6.8v-22.1zm6.8 9.4h1.7c1.3 0 2.2-.2 2.8-.7.5-.5.8-1 .8-1.7s-.2-1.3-.7-1.8c-.5-.5-1.3-.7-2.6-.7h-1.9v4.9zM516.5 332.2h6.8v16.6h10.6v5.4h-17.4v-22zM537.3 332.2h6.8v22h-6.8v-22zM562.5 350.5h-7.7l-1.1 3.6h-6.9l8.3-22h7.4l8.3 22h-7.1l-1.2-3.6zm-1.4-4.7l-2.4-7.9-2.4 7.9h4.8zM572.9 332.2h6.3l8.3 12.2v-12.2h6.4v22h-6.4l-8.2-12.1v12.1h-6.4v-22zM596.9 332.2h20.7v5.4h-6.9v16.6h-6.8v-16.6H597v-5.4z"
    }
  )), /* @__PURE__ */ s.createElement(
    "g",
    {
      id: "pci-dss-compliant-logo_svg__Rectangle-3-_x2B_-Letters",
      transform: "translate(0 8.5)"
    },
    /* @__PURE__ */ s.createElement(
      "path",
      {
        id: "pci-dss-compliant-logo_svg__Rectangle-3",
        className: "pci-dss-compliant-logo_svg__st1",
        d: "M348.7 357.2l19.7-6.2-6.4-14.2c-4.7 5.9-9.4 13.5-13.3 20.4zm-6.7-64.9l-38.6-86-282.6 16 78.3 213.6 150.7-47.5c-9.6-13.8-13.1-30.2-2-38.2 12.4-9 31.1 1.4 43 16.1 11.5-19.2 43.8-63.9 51.2-74z"
      }
    ),
    /* @__PURE__ */ s.createElement(
      "g",
      {
        id: "pci-dss-compliant-logo_svg__Letters",
        transform: "translate(101.996 41.35)"
      },
      /* @__PURE__ */ s.createElement(
        "path",
        {
          id: "pci-dss-compliant-logo_svg__Oval-1",
          className: "pci-dss-compliant-logo_svg__st2",
          d: "M192.6 227.1c11.8 0 21.4-9 21.4-20.2s-9.6-20.2-21.4-20.2c-11.8 0-21.4 9-21.4 20.2 0 11.1 9.6 20.2 21.4 20.2zm-17.5 8.7h35v91.5h-35v-91.5z"
        }
      ),
      /* @__PURE__ */ s.createElement(
        "path",
        {
          id: "pci-dss-compliant-logo_svg__Path-3",
          className: "pci-dss-compliant-logo_svg__st2",
          d: "M157.8 262.5c.3.1.5 0 .5-.3V239c0-.3-.2-.6-.5-.8 0 0-4.6-3-18.6-3.8-.7-.4-13-.5-16.3 0-51 4.1-52.9 41-52.9 42.6v9c0 1.1 0 38.8 52.9 42.1 5.2.4 15.3 0 16.3 0 12.2 0 20.6-3.7 20.6-3.7.3-.1.5-.4.5-.7V302c0-.3-.2-.4-.4-.2 0 0-3.8 3-20.4 4.7-4.7.5-7 .3-8.7 0-23.6-4-24.7-21.2-24.7-21.2 0-.3-.1-.8-.1-1v-6.6c0-.3 0-.8.1-1 0 0 1.6-18.5 24.7-20.5h8.7c10.1 1.3 18.3 6.3 18.3 6.3z"
        }
      ),
      /* @__PURE__ */ s.createElement(
        "path",
        {
          id: "pci-dss-compliant-logo_svg__Path-1",
          className: "pci-dss-compliant-logo_svg__st2",
          d: "M-27.2 327c0 .3.2.5.5.5H7.4c.3 0 .5-.2.5-.5v-26.6c0-.3.2-.5.5-.5 0 0 54.5 3.9 54.5-32.6 0-28.9-34.2-32-45.4-31.5h-44.2c-.3 0-.5.2-.5.5V327zm34.5-47.4v-23.9h8.4s12.1.5 13.1 8.8c.2.6.2 4.7 0 4.9-1.6 9.7-12.1 10.2-12.1 10.2H7.3z"
        }
      )
    ),
    /* @__PURE__ */ s.createElement(
      "path",
      {
        id: "pci-dss-compliant-logo_svg__Path-7",
        d: "M295.6 412.8c2.8 0 5 0 8.6-1.6 12.4-6.5 54.3-108.8 98.5-140.3.3-.2.6-.5.8-.8.3-.4.3-.8.3-.8s0-2.1-6.5-2.1c-39.3-1.1-80.2 81.4-101.7 114-.3.4-1.7 0-1.7 0s-14.4-17-26.9-23.5c-.3-.1-1.7-.6-3.2-.5-1 0-6.8 1.2-9.5 4-3.2 3.4-3.1 5.3-3.1 9.4 0 .3.2 1.7.6 2.4 3.1 5.4 17 24.6 28.5 35.2 1.7 1.3 4.4 4.6 15.3 4.6z",
        fill: "#2bbc5d"
      }
    )
  ), /* @__PURE__ */ s.createElement("g", { className: "pci-dss-compliant-logo_svg__st0" }, /* @__PURE__ */ s.createElement(
    "path",
    {
      className: "pci-dss-compliant-logo_svg__st1",
      d: "M414.3 248.5H447c6.5 0 11.7.9 15.6 2.6 4 1.8 7.3 4.3 9.8 7.5 2.6 3.3 4.5 7.1 5.6 11.4 1.2 4.3 1.8 8.9 1.8 13.8 0 7.6-.9 13.5-2.6 17.7-1.7 4.2-4.1 7.7-7.2 10.6-3.1 2.8-6.4 4.7-9.9 5.7-4.8 1.3-9.2 1.9-13.1 1.9h-32.7v-71.2zm22 16.1v38.9h5.4c4.6 0 7.9-.5 9.8-1.5s3.5-2.8 4.6-5.3c1.1-2.5 1.7-6.7 1.7-12.4 0-7.6-1.2-12.7-3.7-15.5-2.5-2.8-6.5-4.2-12.3-4.2h-5.5zM485.9 296.2l21-1.3c.5 3.4 1.4 6 2.8 7.8 2.3 2.9 5.5 4.3 9.7 4.3 3.1 0 5.6-.7 7.3-2.2 1.7-1.5 2.6-3.2 2.6-5.1 0-1.8-.8-3.5-2.4-5-1.6-1.5-5.4-2.8-11.3-4.1-9.7-2.2-16.5-5.1-20.7-8.7-4.2-3.6-6.2-8.2-6.2-13.8 0-3.7 1.1-7.1 3.2-10.4 2.1-3.3 5.3-5.8 9.6-7.7 4.3-1.9 10.1-2.8 17.5-2.8 9.1 0 16.1 1.7 20.8 5.1 4.8 3.4 7.6 8.8 8.5 16.2l-20.8 1.2c-.6-3.2-1.7-5.5-3.5-7s-4.2-2.2-7.3-2.2c-2.6 0-4.5.5-5.8 1.6-1.3 1.1-1.9 2.4-1.9 4 0 1.1.5 2.2 1.6 3.1 1 .9 3.5 1.8 7.4 2.6 9.6 2.1 16.5 4.2 20.7 6.3 4.2 2.1 7.2 4.8 9.1 7.9 1.9 3.1 2.8 6.7 2.8 10.6 0 4.6-1.3 8.8-3.8 12.6-2.5 3.9-6.1 6.8-10.6 8.8-4.5 2-10.3 3-17.2 3-12.1 0-20.5-2.3-25.2-7-4.6-4.7-7.2-10.6-7.9-17.8z"
    }
  )), /* @__PURE__ */ s.createElement("g", { className: "pci-dss-compliant-logo_svg__st0" }, /* @__PURE__ */ s.createElement(
    "path",
    {
      className: "pci-dss-compliant-logo_svg__st1",
      d: "M556.2 296.2l21-1.3c.5 3.4 1.4 6 2.8 7.8 2.3 2.9 5.5 4.3 9.7 4.3 3.1 0 5.6-.7 7.3-2.2 1.7-1.5 2.6-3.2 2.6-5.1 0-1.8-.8-3.5-2.4-5-1.6-1.5-5.4-2.8-11.3-4.1-9.7-2.2-16.5-5.1-20.7-8.7-4.1-3.6-6.2-8.2-6.2-13.8 0-3.7 1.1-7.1 3.2-10.4 2.1-3.3 5.3-5.8 9.6-7.7 4.3-1.9 10.1-2.8 17.5-2.8 9.1 0 16.1 1.7 20.8 5.1 4.8 3.4 7.6 8.8 8.5 16.2l-20.8 1.2c-.6-3.2-1.7-5.5-3.5-7s-4.2-2.2-7.3-2.2c-2.6 0-4.5.5-5.8 1.6-1.3 1.1-1.9 2.4-1.9 4 0 1.1.5 2.2 1.6 3.1 1 .9 3.5 1.8 7.4 2.6 9.6 2.1 16.5 4.2 20.7 6.3 4.2 2.1 7.2 4.8 9.1 7.9 1.9 3.1 2.8 6.7 2.8 10.6 0 4.6-1.3 8.8-3.8 12.6-2.5 3.9-6.1 6.8-10.6 8.8-4.5 2-10.3 3-17.2 3-12.1 0-20.5-2.3-25.2-7-4.7-4.7-7.3-10.6-7.9-17.8z"
    }
  )))
), e = l;
export {
  e as default
};
